import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Icon from "../../../components/Icon";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ErrorMessage from "../../../components/ErrorMessage";
import OperatorIcon from "../../../components/OperatorIcon";
import { authContext } from "../../../context/AuthContext/AuthContext";
import { forgotPasswordValidation } from "../../../utils/validation/validation";

const ForgetPasswordAuth = () => {
  const { handleForgetPassword } = useContext(authContext);

  // Validation
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordValidation),
  });

  return (
    <>
      <SiteTitle title="فراموشی کلمه عبور" />

      <section className="auth forgot-password-page bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="/assets/images/auth/forgot-pass-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div className="text-center">
              <Link to="/" className="mb-40 max-w-290-px">
                <img src="/assets/images/logo.jpg" alt="" />
              </Link>
              <h4 className="mb-12">فراموشی کلمه عبور</h4>
              <p className="mb-32 text-secondary-light text-lg">
                لطفا کد ملی و شماره موبایل خود را وارد کنید تا کلمه عبور جدید را
                برای شما ارسال کنیم
              </p>
            </div>
            <form
              autoComplete="off"
              onSubmit={handleSubmit(handleForgetPassword)}
            >
              <div className="mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mage:id-card" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="کدملی"
                    inputMode="numeric"
                    {...register("nationalNumber")}
                  />
                </div>
                <ErrorMessage message={errors.nationalNumber?.message} />
              </div>
              <div className="mb-20">
                <div className="position-relative ">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="quill:phone" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      placeholder="شماره موبایل"
                      inputMode="numeric"
                      {...register("phoneNumber")}
                    />
                  </div>
                  <OperatorIcon phoneNumber={watch("phoneNumber")} />
                </div>
                <ErrorMessage message={errors.phoneNumber?.message} />
              </div>
              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                ارسال
              </button>
              <div className="text-center">
                <Link
                  to="/auth/login"
                  className="text-primary-600 fw-bold mt-24"
                >
                  بازگشت به ورود حساب کاربری
                </Link>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgetPasswordAuth;
